export default __webpack_public_path__ + "static/sat-6cba06238d0612339833d4275ec68424.mp4";